import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tipoPersonaName',
    standalone: false
})
export class TipoPersonaNamePipe implements PipeTransform {

  transform(tipoPersona: string): string {
    let returnTipo: string;
    switch (tipoPersona) {
      case 'F':
        returnTipo = 'Persona Natural';
        break;
      case 'J':
        returnTipo = 'Empresa';
        break;
      case 'S':
        returnTipo = 'Sucesión';
        break;
      case 'V':
        returnTipo = 'Vehículo';
        break;
      default:
        returnTipo = '';
        break;
    }
    return returnTipo;
  }

}
